import { ANY } from './getters';
import { ADD as ADD_ACTION } from './actions';
import {
  ADD as ADD_MUTATION,
  REMOVE as REMOVE_MUTATION
} from './mutations';

/**
 * Keeps track of pending operations as Promises.
 */
export default {
  namespaced: true,

  state() {
    return {
      _pendingOps: []
    };
  },

  getters: {
    /**
     * Returns true if any pending operations exist
     */
    [ANY]: ({ _pendingOps }) => _pendingOps.length > 0
  },

  actions: {
    /**
     * Add a new pending operation. The operation will be removed
     * from the store when the promise is resolved.
     *
     * @param {Object} context Vuex context param
     * @param {Promise} promise A Promise for a pending operation
     */
    [ADD_ACTION]({ commit }, promise) {
      commit(ADD_MUTATION, promise);
      promise.finally(() => commit(REMOVE_MUTATION, promise));
    }
  },

  mutations: {
    /**
     * Add a new pending operation.
     *
     * @param {Object} state Vuex state
     * @param {Promise} promise The Promise to add to the store state
     */
    [ADD_MUTATION]({ _pendingOps }, promise) {
      if (!_pendingOps.includes(promise)) _pendingOps.push(promise);
    },

    /**
     * Remove a pending operation.
     *
     * @param {Object} state Vuex state
     * @param {Promise} promise The Promise to add to the store state
     */
    [REMOVE_MUTATION]({ _pendingOps }, promise) {
      _pendingOps.splice(_pendingOps.indexOf(promise), 1);
    }
  }
};
